module.exports = __webpack_public_path__ + "static/media/icon_valid.a122ac40.svg";